import { GeoJSON } from 'leaflet';
import { pointInLayer } from '@mapbox/leaflet-pip';
import orderBy from 'lodash/orderBy';

export default {

  state: {
    results: null,
  },

  mutations: {

    CLEAR_IDENTIFY_RESULTS(state) {
      state.results = null;
    },

    SET_IDENTIFY_RESULTS(state, payload) {
      state.results = payload;
    },

  },

  actions: {

    identifyLatLngInServiceAreas({ getters, commit }, latlng) {
      if (!latlng) {
        throw(new Error({ msg: 'No latlng provided for \'identifyLatLngInServiceAreas\' action.' }));
      }

      commit('CLEAR_IDENTIFY_RESULTS');

      const layer = new GeoJSON(getters.serviceAreas, {
        // options
        pointToLayer(geoJsonPoint, latlng) {
        },
        style(geoJsonFeature) {
        },
        onEachFeature(feature, layer) {
        },
        filter(geoJsonFeature) {
          return true;
        },
      });

      const results = pointInLayer(latlng, layer).map(item => item.feature);
      const ordered = orderBy(results, ['properties.Speeds_mbps', 'properties.Location'], ['desc', 'asc']);

      commit('SET_IDENTIFY_RESULTS', ordered);

      console.log(`Identify in service areas layer found ${ordered.length} results`);

      return ordered;
    }

  },

};
